module.exports = __webpack_public_path__ + "img/memberReport_laying-patient.cfaa2208.svg";